import * as Ariakit from '@ariakit/react';
import { forwardRef, useContext } from '@wordpress/element';
import { Icon, check } from '@wordpress/icons';
import { Context } from './context';
import * as Styled from './styles';
import { useMenuItemHideOnClick } from './use-menu-item-hide-on-click';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CheckboxItem = forwardRef(function CheckboxItem({
  suffix,
  children,
  disabled = false,
  hideOnClick = false,
  ...props
}, ref) {
  const menuContext = useContext(Context);
  const store = menuContext?.store;
  const computedHideOnClick = useMenuItemHideOnClick(store, hideOnClick);
  if (!store) {
    throw new Error('Menu.CheckboxItem can only be rendered inside a Menu component');
  }
  return /*#__PURE__*/_jsxs(Styled.CheckboxItem, {
    ref: ref,
    ...props,
    accessibleWhenDisabled: true,
    disabled: disabled,
    store: store,
    hideOnClick: computedHideOnClick,
    children: [/*#__PURE__*/_jsx(Ariakit.MenuItemCheck, {
      store: store,
      render: /*#__PURE__*/_jsx(Styled.ItemPrefixWrapper, {})
      // Override some ariakit inline styles
      ,
      style: {
        width: 'auto',
        height: 'auto'
      },
      children: /*#__PURE__*/_jsx(Icon, {
        icon: check,
        size: 24
      })
    }), /*#__PURE__*/_jsxs(Styled.ItemContentWrapper, {
      children: [/*#__PURE__*/_jsx(Styled.ItemChildrenWrapper, {
        children: children
      }), suffix && /*#__PURE__*/_jsx(Styled.ItemSuffixWrapper, {
        children: suffix
      })]
    })]
  });
});